export enum PdfReportError {
  UNKNOWN = 'E40000',            // fatal  - unexpected error
  IMAGE_LOAD_FAILED = 'E40001',  // partial - an image could not be fetched (CORS / network)
  PAGE_RENDER_TIMEOUT = 'E40002',// partial - html2canvas timed out on a page
  PAGE_RENDER_FAILED = 'E40003', // partial - html2canvas failed on a page
  CONTENT_NOT_FOUND = 'E40004',  // fatal  - #pdf-content element missing
  NO_PAGES_GENERATED = 'E40005', // fatal  - no page could be rendered
  EXPORT_FAILED = 'E40006',      // fatal  - jsPDF blob export failed
}

export const PDF_REPORT_ERROR_CATALOG: Record<PdfReportError, string> = {
  [PdfReportError.UNKNOWN]: 'Error inesperado generando el PDF',
  [PdfReportError.IMAGE_LOAD_FAILED]: 'Imagen no cargada (posible CORS / red)',
  [PdfReportError.PAGE_RENDER_TIMEOUT]: 'Timeout renderizando una hoja',
  [PdfReportError.PAGE_RENDER_FAILED]: 'Fallo al renderizar una hoja (html2canvas)',
  [PdfReportError.CONTENT_NOT_FOUND]: 'No se encontró el contenido del reporte (#pdf-content)',
  [PdfReportError.NO_PAGES_GENERATED]: 'No se generó ninguna hoja del reporte',
  [PdfReportError.EXPORT_FAILED]: 'Fallo al exportar el PDF (blob)',
};

export const PDF_REPORT_ERROR_I18N_KEY = 'PDF_REPORT.GENERATION_ERROR';

export class PdfGenerationError extends Error {
  constructor(public readonly code: PdfReportError) {
    super(PDF_REPORT_ERROR_CATALOG[code]);
    this.name = 'PdfGenerationError';
  }
}

export function logPdfError(code: PdfReportError, detail?: unknown): void {
  console.error(`[PDF] ${code} - ${PDF_REPORT_ERROR_CATALOG[code]}`, detail ?? '');
}

export function logPdfWarning(code: PdfReportError, detail?: unknown): void {
  console.warn(`[PDF] ${code} - ${PDF_REPORT_ERROR_CATALOG[code]}`, detail ?? '');
}
